import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slot, Slottable } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { Loader2Icon } from "lucide-react";
import * as React from "react";
import { cn } from "../cn";
const buttonVariants = cva("inline-flex select-none items-center justify-center whitespace-nowrap rounded-full font-title text-sm font-normal transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        // todo: standardise these; in sync with design system
        variant: {
            default: "bg-brand-800 text-primary-inverse hover:bg-brand-500/90",
            destructive: "bg-danger text-white hover:bg-danger/90",
            outline: "border border-zinc-500 bg-white text-primary hover:border-primary hover:bg-brand-500/5",
            "outline-brand": "border border-zinc-500 bg-white text-primary hover:text-brand-500 hover:border-brand-500",
            "outline-destructive": "border border-danger bg-white text-danger hover:bg-danger/5",
            "outline-transparent": "border border-transparent bg-white text-transparent hover:bg-brand-500/5",
            // todo: rename the other to outline-primary and this to outline-gray?  same for ghost
            "outline-gray": "border border-zinc-500 bg-white hover:bg-secondary-interactive hover:text-primary",
            "dashed-outline-gray": "border border-dashed border-zinc-500 bg-white hover:bg-secondary-interactive hover:text-primary",
            secondary: "bg-secondary text-primary hover:bg-secondary/80",
            ghost: "text-primary hover:bg-secondary-interactive",
            "ghost-gray": "hover:bg-secondary-interactive hover:text-primary",
            link: "text-primary-interactive underline underline-offset-4",
            "link-primary": "text-primary underline underline-offset-2",
            "link-org": "text-primary",
            party: "bg-white transition-colors hover:bg-secondary-interactive hover:text-primary disabled:border disabled:border-zinc-500",
        },
        size: {
            default: "h-10 px-4",
            xs: "h-7  px-2 text-xs",
            "xs-link": "h-auto p-0 text-xs",
            link: "h-auto p-0",
            "sm-link": "h-auto p-0 text-sm",
            sm: "h-8 rounded-full px-4",
            lg: "h-11 rounded-full px-8",
            xl: "h-12 rounded-full px-4",
            icon: "size-9",
            "icon-sm": "size-6",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
const Button = React.forwardRef(({ className, variant, size, asChild = false, loading, children, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    const body = (_jsxs(Comp, { className: cn(buttonVariants({ variant, size, className })), "data-dd-action-name": props.trackingName, ref: ref, ...props, children: [loading ? _jsx(Loader2Icon, { className: "me-[0.8ch] animate-spin" }) : null, _jsx(Slottable, { children: children })] }));
    if (variant === "party" && !props.disabled) {
        return (_jsx("div", { className: "inline-block h-fit rounded-full bg-[linear-gradient(221.2deg,#0066FF_0%,#DEEAFF_50.06%,#4F46E5_97.41%)] p-[1px]", children: body }));
    }
    return body;
});
Button.displayName = "Button";
export { Button, buttonVariants };
